module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-04.f2b2be1.webp";